export const prescriptionUsage = [
    { tempoUsoNome: "Permanente" },
    { tempoUsoNome: "Ocasional" },
];
